import React from 'react';
import { Header } from './header';

interface PageLayoutProps {
  title: string;
  description: string;
  showHero?: boolean;
  children: React.ReactNode;
  className?: string;
}

export function PageLayout({
  title,
  description,
  showHero = true,
  children,
  className = ""
}: PageLayoutProps) {
  return (
    <div className={`min-h-screen bg-background ${className}`}>
      <Header
        showHero={showHero}
        title={title}
        description={description}
      />

      <div className="flex-1">
        {children}
      </div>
    </div>
  );
}